<!-- 定时管理描述表单 -->
<template>
     <el-form :model="handleControlForm" status-icon :rules="rules" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
        <el-form-item label="状态" prop="power_on">
            <el-select v-model="handleControlForm.power_on" clearable placeholder="请选择">
                <el-option label="开机" value="1"></el-option>
                <el-option label="关机" value="0"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="风速" prop="speed">
            <el-select v-model="handleControlForm.speed" clearable placeholder="请选择">
                <el-option label="自动" value="0"></el-option>
                <el-option label="高风" value="1"></el-option>
                <el-option label="中风" value="2"></el-option>
                <el-option label="低风" value="3"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="模式" prop="mode">
            <el-select v-model="handleControlForm.mode" clearable placeholder="请选择">
                <el-option label="制冷" value="0"></el-option>
                <el-option label="通风" value="1"></el-option>
                <el-option label="制热" value="2"></el-option>
                <el-option label="自动" value="3"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="温度设置" prop="temperature">
            <el-input v-model="handleControlForm.temperature" style="max-width: 221px;"
                @blur="handleChangeInput('temperature')" 
                clear 
                placeholder="请输入温度"></el-input>
        </el-form-item>
		<el-form-item label="锁定" prop="keyBoardlock">
		    <el-select v-model="locks" multiple placeholder="请选择" @change="changelock">
		        <el-option
		              v-for="item in options"
		              :key="item.value"
		              :label="item.label"
		              :value="item.value"
					  :disabled="item.disabled">
		        </el-option>
		    </el-select>
		</el-form-item>
        <!-- <el-form-item label="锁定" prop="key_lock">
            <el-select v-model="handleControlForm.key_lock" clearable placeholder="请选择">
                <el-option label="解除锁定" value="0"></el-option>
                <el-option label="锁定开关机" value="1"></el-option>
                <el-option label="锁定模式" value="2"></el-option>
                <el-option label="锁定风速" value="3"></el-option>
                <el-option label="锁定温度设置" value="4"></el-option>
                <el-option label="锁定所有按键操作" value="5"></el-option>
            </el-select>
        </el-form-item> -->
    </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'

export default {
    name:  'CmpControlForm',
    props: ["index", "parentData"],
    inject: ["reload"],
    data() {
        return {
            handleControlForm: {
                power_on: '',             //  开关机：1
                speed: '',            //  风速：0
                mode: '',         //  模式：0
                temperature: '',        //  设置温度：0
                key_lock: '',          //  按键锁：0
            },
			locks:[],
			options:[{
			          value: 1,
			          label: '锁定开关机',
			        }, {
			          value: 2,
			          label: '锁定模式',
			        }, {
			          value: 4,
			          label: '锁定风速',
			        }, {
			          value: 8,
			          label: '锁定温度',
			        }, {
			          value: 0,
			          label: '解除锁定'
			        }, {
			          value: 15,
			          label: '锁定全部'
			        }],	
            rules: {},
        };
    },
    computed: {
        ...mapGetters(["timeDesc","settingTime", "timeControlMeters", 'timeControlForm']),
        controlType() {
            return this.timeDesc.devtype
        }
    },
    watch: {
        index(newVal, oldVal) {
            if(newVal == 5 && oldVal == 4) {
                // 保存
                this.next()
            }
        },
        parentData(newVal) {
            this.handleControlForm = Object.assign(this.handleControlForm, newVal);
			this.locks =this.getloxcks(this.handleControlForm)
        }
    },
    created() {
        this.handleControlForm = Object.assign(this.handleControlForm, this.parentData);
		// this.getloxcks(this.handleControlForm)
    },
    
    methods: {
        next() {
            this.$store.dispatch("setControlForm", this.handleControlForm).then(res=>{
                this.addTimer();
            })
        },
		getloxcks(v){
			var arr=[]
			// let key_lock = v.key_lock * 1
			var key_lock = + v.key_lock
			if(key_lock == 0){
				return [0]
			}
			if(key_lock == 15){
				return [15]
			}
			let str = key_lock.toString(2)
			var strarr = str.split("")
			// var lockarr = [1,2,4,8]
			var lockarr = [8,4,2,1]
			var num = 4 - strarr.length
			if(strarr.length != 4){
				for(var j = 0 ; j < num;j++){
					strarr.unshift('0')
				}
			}
			for(var i = 0 ; i < lockarr.length;i++){
				if(strarr[i] == "1"){
					arr.push(lockarr[i])
				}
			}
			return arr
		},
		async changelock(val){
			for(var i = 0 ; i<val.length;i++){
				if(val[i] == 0){
					this.locks = [0]
				}
				if(val[i] == 15){
					this.locks = [15]
				}
			}
			this.handleControlForm.key_lock = null
			this.locks.map(v =>{
				this.handleControlForm.key_lock += v * 1
			})
			this.handleControlForm.key_lock = JSON.stringify(this.handleControlForm.key_lock)
		},
        async addTimer() {
            let params = Object.assign({}, this.timeDesc);  //  定时描述
            params.timerkind = this.timeDesc.timerkind[this.timeDesc.timerkind.length-1];   //  只保留最后一级ID
            params.timer_time = this.settingTime;  //  定时时间
            params.timer_control_dev = this.timeControlMeters;   //  控制对象
            params.timer_control_value = this.fmtData(); //  控制参数
            let data
            if(params.oid > 0) {
                // 修改
                data = await Service.editTimer(params);
            }else{
                // 新增
                data = await Service.addTimer(params);
            }
            if(data) {
                this.$message({
                    type: "success",
                    message: "操作成功"
                })
                this.$router.push('/timing')
            }
        },
        fmtData(){
            let arr = [];
            let _t = this;
            for (const key in this.handleControlForm) {
                const element = _t.handleControlForm[key];
                let obj = {}
                obj["N"] = key
                if(element == '') {
                    // obj["V"] = "255"
                }else{
                    obj["V"] = element
                }
                arr.push(obj);
            }
            return arr
        },
        handleChangeInput(key, val) {
            let value = this.handleControlForm[key];
            if(isNaN(value) || value<10 || val>50) {
                this.$message({
                    type: "warn",
                    message: "温度可设置范围10-50;"
                })
                this.handleControlForm[key] = "";
            }
        },
    }
}

</script>
<style lang='less' scoped>

</style>